import { BaseConfig } from './configs/base.config';

export class DataEntryTabsConfig {
  public patient!: BaseConfig;
  public clinical!: BaseConfig;
  public physician!: BaseConfig;
  public insurance!: BaseConfig;
  public prescription!: BaseConfig;
  public consent!: BaseConfig;
}